RivalIQ.apps.Site.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.ExtendedSignupForm = Marionette.LayoutView.extend({
        template: '#siteExtendedSignupFormTemplate',

        onRender: function () {
            const me = this;

            const prefillableProperties = ['companyName', 'companyTitle', 'companyType'];
            _.each(prefillableProperties, prefillableProperty => {
                const prefillValue = me.model.get(`prefill${_.upperFirst(prefillableProperty)}`);
                if (prefillValue) {
                    const input = me.$el.find(`input[name="${prefillableProperty}"], select[name="${prefillableProperty}"]`);
                    input.val(prefillValue);

                    const container = me.$el.find(`.x-${_.kebabCase(prefillableProperty)}-container`);
                    container.hide();
                }
            });
        }
    });
});
